
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/functions';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDLKUFDDRbbi5Yrbf9p4-yxb655NUjdb78",
  authDomain: "bluepearl-e9750.firebaseapp.com",
  projectId: "bluepearl-e9750",
  storageBucket: "bluepearl-e9750.firebasestorage.app",
  messagingSenderId: "1061160236560",
  appId: "1:1061160236560:web:551a93a35d49dbacc97c95",
  measurementId: "G-D5MLGS3YXX"
};
  

export const app = firebase.apps.length
  ? firebase.app()
  : firebase.initializeApp(firebaseConfig);
export const db = app.firestore();
export const auth = app.auth();
export const storage = app.storage();
export const functions = app.functions();

// 🔐 Firestore rules ki chabi (2026-07-16): rules `request.auth != null`
// maangte hain. Customer apna login karta hai to wahi chalta hai; GUEST
// (bina login browse/catalog) ke liye chupchaap anonymous token — koi UI
// nahi, koi farak nahi. Dhandhe ka data (erp_*, Campus*, hisaab) is token
// se NAHI khulta — wo sirf whitelisted chabi-login se khulta hai.
let markAuthReady;
const authReadyPromise = new Promise((resolve) => { markAuthReady = resolve; });
auth.onAuthStateChanged((user) => {
  if (user) markAuthReady(user);
  else auth.signInAnonymously().catch((e) => { console.log('anon auth', e?.message || e); markAuthReady(null); });
});

// Reads made before the first sign-in settles are rejected by the rules.
export const authReady = (timeoutMs = 5000) =>
  Promise.race([authReadyPromise, new Promise((resolve) => setTimeout(resolve, timeoutMs))]);

export default firebase;